import { Box, Button, Grid, Typography, Card, CardContent, CardActions } from "@mui/material";
import { featureStructure } from "../../model/pageList";

interface NavigationPageProps {
    setCurrentView: (view: string) => void;
}

export default function NavigationPage(props: NavigationPageProps) {
    return (
      <Box sx={{ flexGrow: 1, p: 2 }}>        <Typography variant="h4" gutterBottom component="div" align="center">
          TL Utility - Professional Toolkit
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 4 }}>
          A comprehensive collection of utilities and tools for developers and professionals
        </Typography>
        
        <Grid container spacing={3}>
          {featureStructure.map((parentFeature, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card 
                elevation={3}
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6
                  }
                }}
              >
                <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 3 }}>
                  <Box sx={{ mb: 2, color: 'primary.main', fontSize: '2rem' }}>
                    {parentFeature.icon}
                  </Box>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {parentFeature.label}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {parentFeature.subFeatures.length} tools available
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {parentFeature.subFeatures.map(sub => sub.label).join(', ')}
                  </Typography>
                </CardContent>
                <CardActions sx={{ p: 2 }}>
                  <Button 
                    variant="contained" 
                    fullWidth 
                    onClick={() => props.setCurrentView(parentFeature.path)}
                  >
                    Explore Tools
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
}